import {
  WhyWorkSection,
  JobOpeningsSection,
  WhatWeOfferSection,
  RecruitmentProcessSection,
  InternshipSection,
} from "@features/residential/components";

interface CareersPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function CareersPage({ hero, footer }: CareersPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <WhyWorkSection />
      <JobOpeningsSection />
      <WhatWeOfferSection />
      <RecruitmentProcessSection />
      <InternshipSection />
      {footer}
    </div>
  );
}
